// This module can be safely imported in non-browser environments (like CI)

import { convertISOCodeToNavigatorLanguage } from "gather-i18n/dist/src/public/utils/utils";

export const getLocaleFilename = (locale: string, commitHash: string) =>
  `/locales/${convertISOCodeToNavigatorLanguage(locale)}.${commitHash}.json`;
